<template>
	<div v-if="!isMobile">
		<div class="page-container flex-centerize flex-column">
			<ClipLoader v-if="!flowData" color="#5F8FF1" size="18px" />
			<div v-else>
				<InstallablePreview class="mb-4" :installableId="installableId" />
				<div class="display-flex flex-column flex-centerize">
					<div class="installation-content-container">
						<div class="setup-menu-container">
							<SetupMenu v-if="configurationIds" :configurationIds="configurationIds" @close="$emit('close', flowData)" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<AppDialogManager />
	</div>
	<MobileNotSupported v-else />
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
const isMobile = require('is-mobile');
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';
import SetupMenu from '@/views/Flow/configurations/SetupMenu';
import { getWorkflow } from '@/store/modules/workflows/getters';
import MobileNotSupported from '@/views/MobileNotSupported.vue';
import InstallablePreview from '@/components/Project/InstallablePreview.vue';
import AppDialogManager from '@/components/dialogs/AppDialogManager/AppDialogManager';
import { hasWorkflowEditGeneralConfigurationPermissions } from '@/store/modules/workflows/getters';
import { getWorkflowData } from '@/store/modules/workflows/actions';

export default {
	name: 'EditInstalledWorkflowConfiguration',
	props: {
		workflowId: { type: Number, required: true },
	},
	components: {
		SetupMenu,
		ClipLoader,
		AppDialogManager,
		InstallablePreview,
		MobileNotSupported,
	},
	computed: {
		...mapGetters([getWorkflow.fullPath, hasWorkflowEditGeneralConfigurationPermissions.fullPath]),
		isMobile() {
			return isMobile();
		},
		flowData() {
			return this[getWorkflow.fullPath](this.workflowId);
		},
		userSetupId() {
			return this.flowData.current_version_user_setup;
		},
		generalSetupId() {
			return this.flowData.current_version_general_setup;
		},
		hasEditGeneralConfigurationPermissions() {
			return this[hasWorkflowEditGeneralConfigurationPermissions.fullPath](this.flowData.id);
		},
		configurationIds() {
			return {
				generalConfigurationId: this.hasEditGeneralConfigurationPermissions ? this.generalSetupId : null,
				userSpecificConfigurationId: this.userSetupId,
			};
		},
		installableId() {
			return this.flowData?.installed_from;
		},
	},
	methods: {
		...mapActions(['selectedWorkflow/selectWorkflowId', getWorkflowData.fullPath]),
	},
	mounted() {
		this['selectedWorkflow/selectWorkflowId']({ id: this.workflowId });
		this[getWorkflowData.fullPath]({ id: this.workflowId });
	},
};
</script>

<style scoped lang="scss">
.content-container {
	min-width: 820px;
	max-width: 820px;

	@media (max-height: 800px) {
		min-height: 640px;
		min-height: 640px;
	}
	@media (min-height: 800px) {
		min-height: 840px;
		min-height: 840px;
	}
	border-radius: 10px;
	box-shadow: 0px 3px 6px var(--shadow-color);
	background: var(--setup-node-container-background);
}

.installation-content-container {
	width: 520px;
	.setup-menu-container {
		@media (max-height: 800px) {
			height: 460px;
		}
		@media (min-height: 800px) {
			height: 640px;
		}
		border-radius: 10px;
		background: var(--bg-color);
		box-shadow: 0px 3px 6px var(--shadow-color);
	}
}

.page-container {
	width: 100vw;
	height: 100vh;
	background: var(--setup-node-container-background);
}
</style>
